module.exports = __webpack_public_path__ + "img/face.cbd4e90f.png";